import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import React from "react";
import styled from "styled-components";
import { VpnKey, Business, Storage, Link as LinkIcon, AccountCircle, Lock, Folder, Email } from "@material-ui/icons";

function TabWms({ values, touched, errors, handleChange }) {
  return (
    <>
      <SectionTitle hidden={values.id === 0}>Configuração WMS</SectionTitle>
      <FormGrid columns={1} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            WMS TOKEN
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="wms_token"
            name="wms_token"
            placeholder="Token do WMS"
            value={values.wms_token}
            onChange={handleChange}
            error={touched.wms_token && Boolean(errors.wms_token)}
            helperText={touched.wms_token && errors.wms_token}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <FormGrid columns={1} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <Business style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            CNPJ Unidade
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="cnpj_unidade"
            name="cnpj_unidade"
            placeholder="00.000.000/0000-00"
            value={values.cnpj_unidade}
            onChange={handleChange}
            error={touched.cnpj_unidade && Boolean(errors.cnpj_unidade)}
            helperText={touched.cnpj_unidade && errors.cnpj_unidade}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <SectionTitle hidden={values.id === 0}>Notificações</SectionTitle>
      <FormGrid columns={1} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <Email style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            E-mail para notificação
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="email_notification"
            name="email_notification"
            placeholder="email@exemplo.com"
            value={values.email_notification || ""}
            onChange={handleChange}
            error={touched.email_notification && Boolean(errors.email_notification)}
            helperText={touched.email_notification && errors.email_notification}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <SectionTitle hidden={values.id === 0}>Configuração FTP</SectionTitle>
      <FormGrid columns={2} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <LinkIcon style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Host FTP
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="ftp_host"
            name="ftp_host"
            placeholder="ftp.exemplo.com"
            value={values.ftp_host}
            onChange={handleChange}
            error={touched.ftp_host && Boolean(errors.ftp_host)}
            helperText={touched.ftp_host && errors.ftp_host}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <FieldLabel>
            <Storage style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Port FTP
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="ftp_port"
            name="ftp_port"
            placeholder="21"
            value={values.ftp_port}
            onChange={handleChange}
            error={touched.ftp_port && Boolean(errors.ftp_port)}
            helperText={touched.ftp_port && errors.ftp_port}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <FormGrid columns={2} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Usuário FTP
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="ftp_user"
            name="ftp_user"
            placeholder="Usuário do FTP"
            value={values.ftp_user}
            onChange={handleChange}
            error={touched.ftp_user && Boolean(errors.ftp_user)}
            helperText={touched.ftp_user && errors.ftp_user}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <FieldLabel>
            <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Senha FTP
          </FieldLabel>
          <TextField
            fullWidth
            type="password"
            InputLabelProps={{ shrink: true }}
            id="ftp_password"
            name="ftp_password"
            placeholder="••••••••"
            value={values.ftp_password}
            onChange={handleChange}
            error={touched.ftp_password && Boolean(errors.ftp_password)}
            helperText={touched.ftp_password && errors.ftp_password}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <FormGrid columns={2} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <Folder style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Pasta FTP
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="ftp_folder"
            name="ftp_folder"
            placeholder="/caminho/pasta"
            value={values.ftp_folder}
            onChange={handleChange}
            error={touched.ftp_folder && Boolean(errors.ftp_folder)}
            helperText={touched.ftp_folder && errors.ftp_folder}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <CheckboxContainer>
            <Checkbox
              id="ftp_enabled"
              name="ftp_enabled"
              checked={values.ftp_enabled}
              onChange={(e) => handleChange({ target: { name: "ftp_enabled", value: e.target.checked } })}
              color="primary"
            />
            <CheckboxLabel>{values.ftp_enabled ? "FTP Ativo" : "FTP Inativo"}</CheckboxLabel>
          </CheckboxContainer>
        </StyledFieldContainer>
      </FormGrid>
    </>
  );
}

export default TabWms;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 24px 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
  font-family: 'Mulish', sans-serif;
  display: ${props => props.hidden ? 'none' : 'block'};

  &:first-child {
    margin-top: 0;
  }
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 1}, 1fr);
  gap: 20px;
  margin-bottom: 24px;
  display: ${props => props.hidden ? 'none' : 'grid'};

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .MuiOutlinedInput-root {
    border-radius: 10px;
    background: white;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(132, 204, 22, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(132, 204, 22, 0.2);
    }
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
  }

  .MuiInputLabel-outlined {
    font-family: 'Mulish', sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background: rgba(132, 204, 22, 0.05);
  border-radius: 10px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(132, 204, 22, 0.1);
  }
`;

const CheckboxLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  font-family: 'Mulish', sans-serif;
`;
